<template>
  <div>
    <div class="mb-4">
      <div class="location-home pt-2.5">
        <!-- <h3 class="fsize20 font-semibold">Home / {{ get_location }}</h3> -->
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="!cardView">
          {{ this.serviceName }}
        </h3>
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="cardView">
          Service Provider
        </h3>
      </div>

      <div class="flex ml-auto lg:mt-0 md:mt-0 mt-4">
        <!-- <b-form-input
          id="input-default"
          label-size="large"
          class=""
        ></b-form-input> -->

        <div class="search">
          <base-button
            @click="handleRoute('request-form', 'request-for-service')"
            type="primary"
            class="search-clr-btn ml-2"
            ><span> Request for Service </span>
            <!-- <span v-if="cardView"> About Service </span> -->
          </base-button>
          <base-button
            @click="handleService"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Know Your Service Provider </span>
          </base-button>
        </div>
      </div>
    </div>
    <div class="" v-show="!cardView">
      <!-- <img
        src="../../../assets/images/nodata.svg"
        alt="image"
        class="sprovider-img mx-auto"
      /> -->

      <!-- <h1 >
        {{ record.title }}
      </h1> -->

      <div v-html="record.description" class="font-bold text-black"></div>
      <!-- <Bcard class="lg:mt-20 md:mt-20 mt-12" v-show="cardView" /> -->
    </div>
    <Bcard1 class="lg:mt-20 md:mt-20 mt-12" v-show="cardView" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bcard from "./Bcard.vue";
import Bcard1 from "../../cg-coaching/components/Bcard.vue";

export default {
  // props: ["location"],
  props: {
    record: { type: Object },
  },
  components: {
    Bcard,
    Bcard1,
  },
  data() {
    return {
      dataFound: false,
      serviceName: "",
      cardView: false,
      description: "Hello",
      title: "NEW Service",
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
      getVolunteerByService: "getVolunteerByService",
    }),
    ...mapState("services", ["selected_service_card"]),
    ...mapState("auth", ["user"]),
  },
  methods: {
    handleRoute(name, params) {
      // if (Object.keys(this.user).length === 0) {
      //   this.$router.push({ name: "signin" });
      //   this.$swal.fire({
      //     title: "",
      //     text: "Please login to access this content",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   return;
      // }
      this.$router.push({ name: name, params: { pathName: params } });
    },
    async handleService() {
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      let loader = this.$loading();
      this.userDetails = sessionStorage.getItem("token");
      try {
        // if (this.userDetails === null) {
        //   this.$swal
        //     .fire({
        //       title: "Login!",
        //       text: "Please login to continue",
        //       icon: "info",
        //       confirmButtonText: "Okay",
        //       confirmButtonColor: "#830c81",
        //       showCancelButton: false,
        //     })
        //     .then((result) => {
        //       return this.$router.push({ name: "signin" });
        //     });
        //   return;
        // }
        this.cardView = !this.cardView;
        let payload = {
          service: this.serviceName,
        };
        let data = await this.$store.dispatch(
          "respitecare/getVolunteerByService",
          payload
        );
        // if (this.getVolunteerByService.length == 0) {
        //   this.$router.push({
        //     name: "care-assistance",
        //     query: {
        //       reqScroll: true,
        //     },
        //   });
        // }
      } catch (error) {
        console.log(error);
      }
      loader.close();
      // this.$router.push({ name: "map-inside", query: { service: true } });
      // let urlToRedirect = `${window.location.origin}/product-services`;
      // localStorage.setItem("bookService", true);
      // window.open(urlToRedirect, "_blank");
    },
    async getServiceData() {
      try {
        const getServices = await this.$store.dispatch("services/get_service", {
          // serviceName: this.$route.query.service,
          serviceId: this.selected_service_card._id,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getServiceData();
    // if (this.get_volunteer_by_location.length > 0) {
    //   this.dataFound = true;
    // }
    this.serviceName = this.$route.query.service;
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.fsize30 {
  font-size: 30px;
}
</style>
